import BaseRequest from './BaseRequest';

const schema = 'manager';
/**
 * key base on host:port
 */
export default class AdminWalletRequest extends BaseRequest {
  /**
	 *
	 * @returns {Promise<BaseRequest._responseHandler.props.data|undefined>}
	 */

  addAdminWallet(params) {
    const url = `${schema}/add-wallet`;
    return this.post(url, params);
  }

  fetchAdminWallet(params) {
    const url = `${schema}/admin-wallets`;
    return this.get(url, params);
  }

  fetchAdminBalances(params) {
    const url = `${schema}/balances`;
    return this.get(url, params);
  }

  fetchAllErrERC20(params) {
    const url = `${schema}/err-erc20`;
    return this.get(url, params);
  }

  fetchAllErrTomoERC20(params) {
    const url = `${schema}/err-tomo-erc20`;
    return this.get(url, params);
  }

  migrateBTC(params) {
    const url = `${schema}/migrate-btc/${params.address}`;
    return this.post(url);
  }

  migrateETH(params) {
    const url = `${schema}/migrate-eth`;
    return this.post(url, params);
  }

  migrateERC20(params) {
    const url = `${schema}/migrate-erc20`;
    return this.post(url, params);
  }

  fixErrERC20() {
    const url = `${schema}/fix-err-erc20`;
    return this.post(url);
  }

  fixErrTomoERC20() {
    const url = `${schema}/fix-err-tomo-erc20`;
    return this.post(url);
  }

  setAdminTransfer(params) {
    const url = `${schema}/admin-transfer/${params.uid}/${params.address}`;
    return this.put(url);
  }
}
